module.exports = __webpack_public_path__ + "static/media/trigger_soundi 8-2-Audio 1.3abcbfc2.mp3";